import api from '@/modules/api'

export default {
  state: {
    nestedModules: [],
    activeModulePath: '',
    BackButtonFlag: 0,
    step1_design: 0,
    step2_design: 0,
    step3_design: 0,
    step4_design: 0,
    step5_design: 0,
    step1_content: 1,
    step2_content: 0,
    step3_content: 0,
    step4_content: 0,
    step5_content: 0,
    isFirstTimeContent: 0,
    isPlusPackage: 0,
    isFirstTimeTemplate: 0
  },
  getters: {
    nestedModules: state => state.nestedModules,
    activeModulePath: state => state.activeModulePath,
    BackButtonFlag: state => state.BackButtonFlag,
    isFirstTimeContent: state => state.isFirstTimeContent,
    step1_design: state => state.step1_design,
    step2_design: state => state.step2_design,
    step3_design: state => state.step3_design,
    step4_design: state => state.step4_design,
    step5_design: state => state.step5_design,
    step1_content: state => state.step1_content,
    step2_content: state => state.step2_content,
    step3_content: state => state.step3_content,
    step4_content: state => state.step4_content,
    step5_content: state => state.step5_content,
    isPlusPackage: state => state.isPlusPackage,
    isFirstTimeTemplate: state => state.isFirstTimeTemplate
  },
  mutations: {
    setNestedModules (state, nestedModules) {
      state.nestedModules = nestedModules
    },
    SET_ACTIVE_MODULE (state, activeModulePath) {
      state.activeModulePath = activeModulePath
    },
    setisPlusPackage (state, IsPlus) {
      state.isPlusPackage = IsPlus
    },
    setBackButtonFlag (state, val) {
      state.BackButtonFlag = val
    },
    setStep1_design (state, val) {
      state.step1_design = val
    },
    setStep2_design (state, val) {
      state.step2_design = val
    },
    setStep3_design (state, val) {
      state.step3_design = val
    },
    setStep4_design (state, val) {
      state.step4_design = val
    },
    setStep5_design (state, val) {
      state.step5_design = val
    },
    setStep1_content (state, val) {
      state.step1_content = val
    },
    setStep2_content (state, val) {
      state.step2_content = val
    },
    setStep3_content (state, val) {
      state.step3_content = val
    },
    setStep4_content (state, val) {
      state.step4_content = val
    },
    setStep5_content (state, val) {
      state.step5_content = val
    },
    setisFirstTimeContent (state, isContent) {
      state.isFirstTimeContent = isContent
    },
    setisFirstTimeTemplate (state, isContent) {
      state.isFirstTimeTemplate = isContent
    }
  },
  actions: {
    async populateNestedModules ({ commit, rootGetters }) {
      const response = await api.subscription.getNestedModules(rootGetters.activeSubscriptionId)
      commit('setNestedModules', response)
    },
    setBackButtonFlag ({ commit }, val) {
      commit('setBackButtonFlag', val)
    },
    FirstTimeContent ({ commit }, val) {
      commit('setisFirstTimeContent', val)
    },
    SetStep1_design ({ commit }, val) {
      commit('setStep1_design', val)
    },
    SetStep1_content ({ commit }, val) {
      commit('setStep1_content', val)
    },
    setActiveModulePath ({ commit }, path) {
      commit('SET_ACTIVE_MODULE', path)
    },
    FirstTimeTemplate ({ commit }, val) {
      commit('setisFirstTimeTemplate', val)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js